// extracted by mini-css-extract-plugin
module.exports = {"activity":"jgp-39fdV","activityIcon":"jgp-17DUm"};